export default function (totalCharge, quantity, transactionId) {
  gtag("event", "conversion", {
    send_to: "AW-978300184",
    value: totalCharge,
    currency: "USD",
    transaction_id: transactionId,
    quantity,
  });

  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    order_id: transactionId,
    content_ids: transactionId,
    content_type: "product",
  });
}
